export default __webpack_public_path__ + "static/media/logo-contact.b3b36a2a.jpg";